import { LocationOn } from '@mui/icons-material';
import React from 'react';

import { Customer, CustomerSearchDTO } from '_lib/api/apiTypes.shim';

import { Box } from '_lib/components/Box/Box';
import { Grid } from '_lib/components/Grid/Grid';
import { List } from '_lib/components/List/List';
import { ListItem } from '_lib/components/ListItem/ListItem';
import { ListItemButton } from '_lib/components/ListItemButton/ListItemButton';
import { Typography } from '_lib/components/Typography/Typography';
import { customerDisplayName, formatAddressOneLine } from '_lib/utils/helpers';

export interface CustomerListProps {
  customerList?: (Customer | CustomerSearchDTO)[];
  selectedCustomer?: Customer;
  onCustomerClicked?: (customer: Customer) => void;
}

export const CustomerList = (props: CustomerListProps): React.ReactElement => {
  const { customerList, selectedCustomer, onCustomerClicked } = props;

  return (
    <Box>
      <List>
        {customerList?.map((customer) => (
          <ListItem key={customer.providerId} divider>
            <ListItemButton
              onClick={() => (onCustomerClicked ? onCustomerClicked(customer) : () => {})}
              selected={customer.providerId === selectedCustomer?.providerId}
              disableRipple>
              <Grid container spacing={1}>
                <Grid item xs={6} sm={12}>
                  <Typography variant='body1Bold' text={customerDisplayName(customer)} />
                </Grid>
                <Grid item xs={6} sm={12}>
                  <Typography text={formatAddressOneLine(customer)} />
                </Grid>
                {(customer as CustomerSearchDTO)?.locations?.map((location) => (
                  <Grid
                    container
                    item
                    direction={'row'}
                    key={`${customer.providerId}-${location.providerId}`}
                    xs={6}
                    sm={12}>
                    <LocationOn />
                    <Typography text={formatAddressOneLine(location)} />
                  </Grid>
                ))}
              </Grid>
            </ListItemButton>
          </ListItem>
        ))}
      </List>
    </Box>
  );
};
